<template>
  <div class="qrcode-page dark-theme">
    <!-- 主内容区 -->
    <div class="qrcode-container">
      <!-- 页面标题 -->
      <div class="page-header">
        <div class="header-icon">
          <a-icon type="qrcode" />
        </div>
        <div class="header-text">
          <h2 class="page-title">{{ translate('qrcode.title') }}</h2>
          <p class="page-description">{{ translate('qrcode.description') }}</p>
        </div>
      </div>
      
      <!-- 网格布局 -->
      <div class="qrcode-grid">
        <!-- 左侧：表单区域 -->
        <div class="grid-item form-side">
          <div class="section-card">
            <div class="card-header">
              <a-icon type="edit" class="card-icon" />
              <h3 class="card-title">{{ translate('qrcode.input_config') }}</h3>
            </div>
            
            <div class="form-container">
              <div class="form-group">
                <label class="form-label">
                  <a-icon type="appstore" />
                  {{ translate('qrcode.protocol_type') }}
                </label>
                <a-select
                  v-model="Selectvalue"
                  class="form-control"
                  :placeholder="translate('qrcode.placeholder1')"
                  @change="handleChange"
                >
                  <a-select-option v-for="item in options" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </div>
              
              <div class="form-group">
                <label class="form-label">
                  <a-icon type="link" />
                  {{ translate('qrcode.connection_info') }}
                </label>
                <a-input
                  class="form-control"
                  v-model="inputValue"
                  @change="onChange"
                  :placeholder="translate('qrcode.placeholder2')"
                />
              </div>
              
              <div class="form-actions">
                <a-button type="primary" class="action-btn" @click="getQrCode">
                  <a-icon type="scan" />
                  {{ translate('qrcode.generate') }}
                </a-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：二维码显示区域 -->
        <div class="grid-item qrcode-side">
          <div class="section-card">
            <div class="card-header">
              <a-icon type="scan" class="card-icon" />
              <h3 class="card-title">{{ translate('qrcode.result_title') }}</h3>
            </div>
            
            <div class="qrcode-result-container">
              <div v-if="!clickValue" class="empty-state">
                <div class="empty-icon">
                  <a-icon type="qrcode" />
                </div>
                <p class="empty-text">{{ translate('qrcode.placeholder3') }}</p>
                <p class="empty-hint">{{ translate('qrcode.placeholder4') }}</p>
              </div>
              
              <div v-else class="qrcode-display">
                <div class="qrcode-wrapper">
                  <qrcode-vue :value="clickValue" :size="size" level="L" class="qrcode-img" />
                </div>
                
                <div class="qrcode-details">
                  <div class="detail-item">
                    <span class="detail-label">{{ translate('qrcode.protocol_type') }}</span>
                    <span class="detail-value">{{ Selectvalue === 'shadowrocket' ? 'Shadowrocket' : 'Socks5' }}</span>
                  </div>
                  <div class="detail-item">
                    <span class="detail-label">{{ translate('qrcode.connection_info') }}</span>
                    <span class="detail-value">{{ maskConnectionInfo(inputValue) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode-vue';

export default {
  name: "QRCodeGenerator",
  components: {
    QrcodeVue
  },
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState?.languageCode || 'zh';
    }
  },
  data() {
    return {
      inputValue: "",
      clickValue: "",
      size: 200,
      Selectvalue: 'shadowrocket',
      options: [
        { label: 'Shadowrocket', value: 'shadowrocket' },
        { label: 'Socks5', value: 'socks5' }
      ]
    };
  },
  methods: {
    translate(key) {
      const lang = this.currentLanguage;
      const dict = {
        'qrcode.title': lang === 'zh' ? '二维码生成' : 'QR Code Generator',
        'qrcode.description': lang === 'zh' ? '将代理连接信息转换为二维码，使用扫一扫快速添加代理' : 'Convert proxy connection information to QR code, use scan to quickly add proxy',
        'qrcode.input_config': lang === 'zh' ? '输入配置' : 'Input Configuration',
        'qrcode.protocol_type': lang === 'zh' ? '协议类型' : 'Protocol Type',
        'qrcode.connection_info': lang === 'zh' ? '连接信息' : 'Connection Information',
        'qrcode.generate': lang === 'zh' ? '生成二维码' : 'Generate QR Code',
        'qrcode.result_title': lang === 'zh' ? '二维码结果' : 'QR Code Result',
        'qrcode.placeholder1': lang === 'zh' ? '请选择协议类型' : 'Please select protocol type',
        'qrcode.placeholder2': lang === 'zh' ? '例如: username:password@ip:port' : 'Example: username:password@ip:port',
        'qrcode.placeholder3': lang === 'zh' ? '请先输入连接信息并点击"生成二维码"' : 'Please enter connection information and click "Generate QR Code"',
        'qrcode.placeholder4': lang === 'zh' ? '支持 Shadowrocket 和 Socks5 协议' : 'Supports Shadowrocket and Socks5 protocols',
        'qrcode.please_enter_info': lang === 'zh' ? '请输入连接信息' : 'Please enter connection information',
        'qrcode.encoding_failed': lang === 'zh' ? '编码失败，请检查输入格式' : 'Encoding failed, please check input format',
        'qrcode.incorrect_format': lang === 'zh' ? '输入格式不正确，请使用 "IP:端口:账号:密码" 格式' : 'Incorrect input format, please use "IP:Port:Username:Password" format'
      };
      return dict[key] || key;
    },
    maskConnectionInfo(info) {
      if (!info) return '-';
      if (info.includes('@')) {
        return info;
      }
      const parts = info.split(':');
      if (parts.length >= 4) {
        return `${parts[0]}:****@${parts[0]}:${parts[1]}`;
      }
      return info;
    },
    getQrCode() {
      if (this.inputValue === '') {
        this.$message.error(this.translate('qrcode.please_enter_info'));
        return;
      }
      
      let url_head = 'socks://';
      let codeInfo;

      if (this.inputValue.includes("@")) {
        if (this.Selectvalue === 'shadowrocket') {
          try {
            this.clickValue = url_head + btoa(unescape(encodeURIComponent(this.inputValue)));
          } catch (e) {
            console.error('Base64 编码失败:', e);
            this.$message.error(this.translate('qrcode.encoding_failed'));
          }
        } else if (this.Selectvalue === 'socks5') {
          this.clickValue = url_head + this.inputValue;
        }
      } else {
        const parts = this.inputValue.split(":");
        if (parts.length < 4) {
          this.$message.error(this.translate('qrcode.incorrect_format'));
          return;
        }
        codeInfo = `${parts[2]}:${parts[3]}@${parts[0]}:${parts[1]}`;
        if (this.Selectvalue === 'shadowrocket') {
          try {
            this.clickValue = url_head + btoa(unescape(encodeURIComponent(codeInfo)));
          } catch (e) {
            console.error('Base64 编码失败:', e);
            this.$message.error(this.translate('qrcode.encoding_failed'));
          }
        } else if (this.Selectvalue === 'socks5') {
          this.clickValue = url_head + codeInfo;
        }
      }
    },
    onChange(e) {
      this.inputValue = e.target.value;
    },
    handleChange(value) {
      this.Selectvalue = value;
    }
  }
};
</script>

<style lang="less" scoped>
// 深色主题全局样式
.dark-theme {
  background: #2d2c28;
  color: #ffffff;
  // min-height: 100vh;
}

// 主容器样式
.qrcode-page {
  padding: 20px;
  min-height: 100vh;
}

.qrcode-container {
  // max-width: 1600px;
  margin: 0 auto;
}

// 页面标题
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  margin-bottom: 24px;
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.header-icon {
  width: 56px;
  height: 56px;
  background: rgba(0, 234, 144, 0.1);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    font-size: 28px;
    color: #00ea90;
  }
}

.header-text {
  flex: 1;
}

.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px 0;
  letter-spacing: 0.5px;
}

.page-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  line-height: 1.6;
}

// 网格布局
.qrcode-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
}

.grid-item {
  display: flex;
  flex-direction: column;
}

.form-side {
  order: 2;
  
  @media (max-width: 1200px) {
    order: 1;
  }
}

.qrcode-side {
  order: 1;
  
  @media (max-width: 1200px) {
    order: 2;
  }
}

// 卡片样式
.section-card {
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  flex: 1;
  
  &:hover {
    border-color: rgba(21, 129, 198, 0.3);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.card-icon {
  font-size: 20px;
  color: #00ea90;
  background: rgba(0, 234, 144, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}

// 表单样式
.form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  
  .anticon {
    color: #00ea90;
    font-size: 16px;
  }
}

.form-control {
  width: 100%;
  padding: 0 !important;
  height: auto;
  
  :deep(.ant-select-selector),
  :deep(.ant-input) {
    background: #1f1e1b !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    border-radius: 10px !important;
    height: 48px !important;
    color: #ffffff !important;
    font-size: 15px !important;
    
    &:focus,
    &:hover {
      border-color: #1581c6 !important;
      box-shadow: 0 0 0 2px rgba(21, 129, 198, 0.2) !important;
    }
    
    input {
      color: #ffffff !important;
      background: transparent !important;
    }
  }
  
  :deep(.ant-select-selection-item) {
    color: #ffffff !important;
    line-height: 46px !important;
  }
  
  :deep(.ant-select-dropdown) {
    background: #33342e !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 10px !important;
  }
  
  :deep(.ant-select-item-option) {
    color: rgba(255, 255, 255, 0.9) !important;
    
    &.ant-select-item-option-selected {
      background: rgba(21, 129, 198, 0.2) !important;
    }
    
    &:hover {
      background: rgba(21, 129, 198, 0.1) !important;
    }
  }
  
  // 确保textarea有明显边框
  :deep(.ant-input-textarea) {
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    
    &:focus {
      border-color: #1581c6 !important;
    }
  }
}

// Form label style
:deep(.ant-form-item-label > label) {
  font-size: 15px;
  font-weight: 600;
  color: #ffffff !important;
  padding: 0 !important;
  margin-right: 0;
}

// Ant Design form item label text
:deep(.ant-form-item-label) {
  color: #ffffff !important;
}

// Ant Design label component
:deep(.ant-form-item-label label) {
  color: #ffffff !important;
}

// 按钮样式
.form-actions {
  margin-top: 20px;
}

.action-btn {
  height: 48px;
  font-size: 15px;
  font-weight: 600;
  padding: 0 32px;
  border-radius: 10px !important;
  line-height: 48px !important;
  background: #1581c6 !important;
  border: none !important;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #ffffff !important;
  width: 100%;
  
  .anticon {
    font-size: 16px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(21, 129, 198, 0.3) !important;
    background: #126ba5 !important;
  }
  
  &:active {
    transform: translateY(0);
  }
}

// 二维码结果容器
.qrcode-result-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  min-height: 400px;
}

// 空状态样式
.empty-state {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: rgba(255, 255, 255, 0.6);
}

.empty-icon {
  width: 80px;
  height: 80px;
  background: rgba(0, 234, 144, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    font-size: 40px;
    color: #00ea90;
  }
}

.empty-text {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.empty-hint {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

// 二维码显示样式
.qrcode-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  width: 100%;
  max-width: 600px;
}

.qrcode-wrapper {
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border: 4px solid #1f1e1b;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 30px rgba(0, 234, 144, 0.2);
    border-color: #00ea90;
  }
  
  .qrcode-img {
    display: block;
    max-width: 100%;
  }
}

// 二维码详情
.qrcode-details {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 400px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  background: #1f1e1b;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
}

.detail-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  font-size: 14px;
  color: #00ea90;
  font-weight: 600;
  word-break: break-all;
}

// 响应式设计
@media (max-width: 768px) {
  .qrcode-page {
    padding: 16px;
  }
  
  .page-header {
    padding: 20px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .header-icon {
    width: 48px;
    height: 48px;
    
    .anticon {
      font-size: 24px;
    }
  }
  
  .page-title {
    font-size: 22px;
  }
  
  .qrcode-result-container {
    padding: 24px 16px;
    min-height: 300px;
  }
  
  .qrcode-wrapper {
    padding: 16px;
    
    :deep(canvas) {
      max-width: 100%;
      height: auto !important;
    }
  }
  
  .qrcode-details {
    max-width: 100%;
  }
}
</style>
